export const regularActionTexts = {
    "say_envido": [
        [
            "Con esta carta",
            "me despido,",
            "aunque te duela,",
            "te canto",
            "un ENVIDO.",
        ],
        [
            "Vení que te explico,",
            "con calma y sentido:",
            "te tengo la justa,",
            "te gano",
            "con ENVIDO.",
        ],
        [
            "De la villa",
            "hasta el centro,",
            "me traje un amigo,",
            "que me susurra al oído:",
            "'¡Cantale un ENVIDO!'",
        ],
        [
            "Este as bajo la manga",
            "no es ningun chiquitito,",
            "me la juego sin miedo,",
            "te clavo",
            "un ENVIDO.",
        ],
        [
            "No te confundas,",
            "no soy distraído,",
            "con esta jugada",
            "te meto",
            "un ENVIDO.",
        ],
        [
            "Mientras tomamos mate",
            "con algún amigo,",
            "sale de la boca,",
            "'¡A ver quién canta ENVIDO!'",
        ],
        [
            "Aunque suene atrevido,",
            "con esta carta,",
            "bien decidido,",
            "te tiro",
            "un ENVIDO.",
        ],
        [
            "De la cancha",
            "al asado compartido,",
            "en la mesa se juega,",
            "y yo canto ENVIDO.",
        ],
        [
            "No te hagas el vivo,",
            "no te hagas el distraído,",
            "mirame a los ojos",
            "y aceptá",
            "mi ENVIDO.",
        ],
        [
            "Con este manual",
            "bien aprendido,",
            "te doy un consejo:",
            "nunca subestimes",
            "un ENVIDO.",
        ]
    ],
    "say_real_envido": [
        [
            "A este juego",
            "tan querido",
            "le sumo uno más",
            "y te canto",
            "REAL ENVIDO."
        ],
        [
            "De tanto jugar",
            "y no haber perdido,",
            "te lo aseguro:",
            "esta vez te gano",
            "con REAL ENVIDO."
        ],
        [
            "Aunque parezca",
            "atrevido,",
            "con este punto extra",
            "te desafío",
            "a un REAL ENVIDO."
        ],
        [
            "Antes de que",
            "huyas despavorido,",
            "dale aceptame",
            "este REAL ENVIDO."
        ],
        [
            "No te achiques,",
            "no seas tímido,",
            "que te estoy cantando",
            "con todas mis ganas",
            "REAL ENVIDO."
        ],
        [
            "Con esta mano",
            "te tengo vencido,",
            "preparate bien",
            "porque viene fuerte",
            "mi REAL ENVIDO."
        ],
        [
            "Si pensás que exagero,",
            "o que ando perdido,",
            "mirá mis cartas:",
            "te clavo seguro",
            "un REAL ENVIDO."
        ],
        [
            "El truco es simple,",
            "sin mucho lío,",
            "pero hoy te reto",
            "a que aceptes este",
            "REAL ENVIDO."
        ],
        [
            "Aunque lo dudes,",
            "aunque no lo creas,",
            "ya está decidido:",
            "con estas cartas",
            "te canto REAL ENVIDO."
        ],
        [
            "Si de coraje",
            "andás servido,",
            "te invito a jugar",
            "y a enfrentarme ahora",
            "con REAL ENVIDO."
        ],
        [
            "En la mesa manda",
            "el que ha sabido,",
            "y yo te lo digo",
            "que hoy te ganamos",
            "con REAL ENVIDO."
        ]
    ],
    "say_falta_envido": [
        [
            "Con esta mano",
            "ya estás perdido,",
            "no te queda otra,",
            "te canto",
            "FALTA ENVIDO"
        ],
        [
            "No te asustes,",
            "no seas cobarde,",
            "que en esta jugada",
            "te canto sin miedo",
            "FALTA ENVIDO"
        ],
        [
            "Si creías que",
            "esto era un chiste,",
            "ahora te aviso,",
            "viene el verdadero",
            "FALTA ENVIDO"
        ],
        [
            "Ya no hay vuelta",
            "ni arrepentido,",
            "la jugada es clara,",
            "y te remato con",
            "FALTA ENVIDO"
        ],
        [
            "Con esta carta",
            "que traigo escondida,",
            "te juego la vida,",
            "y canto enorme",
            "FALTA ENVIDO"
        ],
        [
            "Aunque te duela,",
            "aunque estés dolido,",
            "te grito con las muelas,",
            "FALTA ENVIDO"
        ],
        [
            "No es para menos,",
            "no es un descuido,",
            "esta mano se gana",
            "con un FALTA ENVIDO"
        ],
        [
            "Si venís confiado,",
            "o medio distraído,",
            "te aviso que esta vez",
            "te clavo seguro",
            "FALTA ENVIDO"
        ],
        [
            "El tanto es así,",
            "no hay más que decir,",
            "te juego el honor,",
            "y te canto ya",
            "FALTA ENVIDO"
        ],
        [
            "Si tenés coraje,",
            "si sos decidido,",
            "vamos mano a mano,",
            "y aceptame este",
            "FALTA ENVIDO"
        ],
        [
            "Con esta carta",
            "me lo juego todo,",
            "no hay otra opción,",
            "te gano directo con",
            "FALTA ENVIDO"
        ]
    ],
    "say_flor": [
        [
            "En la mesa",
            "no hay error,",
            "cuando abro mi mano,",
            "aparece una FLOR"
        ],
        [
            "No es suerte,",
            "es puro sabor,",
            "mirá estas cartas,",
            "te canto alegre",
            "FLOR"
        ],
        [
            "No te hagas el vivo,",
            "ni te sientas mejor,",
            "porque en esta ronda",
            "te clavo una",
            "FLOR"
        ],
        [
            "Desde el barrio",
            "hasta el salón,",
            "todos saben bien",
            "que aquí se gana con",
            "FLOR"
        ],
        [
            "En esta mano,",
            "te traigo el color,",
            "y con todo orgullo",
            "te canto mi",
            "FLOR"
        ],
        [
            "No es fácil ganar,",
            "ni salir triunfador,",
            "pero con estas cartas",
            "yo te canto una",
            "FLOR"
        ],
        [
            "No te confundas,",
            "no hay margen de error,",
            "mi juego es perfecto,",
            "te cierro con una",
            "FLOR"
        ],
        [
            "No es cualquier mano,",
            "ni es casualidad,",
            "porque cuando juego,",
            "te canto alegre",
            "FLOR"
        ],
        [
            "De tanto jugar",
            "con pasión y fervor,",
            "al fin en mi mano,",
            "me salió esta",
            "FLOR"
        ],
        [
            "No hay más secreto,",
            "no hay más dolor,",
            "porque con estas cartas,",
            "te gano con una",
            "FLOR"
        ],
        [
            "Si te sorprende,",
            "no sientas rencor,",
            "porque con estas cartas,",
            "yo te canto",
            "FLOR"
        ]
    ],
    "say_con_flor_quiero": [
        [
            "No te achiques,",
            "ni me saques el cuero,",
            "con esta mano te digo:",
            "jugate todo,",
            "CON FLOR QUIERO"
        ],
        [
            "Si estás listo,",
            "y te creés sincero,",
            "demostralo ahora,",
            "porque yo te canto",
            "CON FLOR QUIERO"
        ],
        [
            "No hay dudas,",
            "ni es un desespero,",
            "con estas cartas en mano,",
            "te grito",
            "CON FLOR QUIERO"
        ],
        [
            "No hay miedo,",
            "no hay pero,",
            "con esta jugada,",
            "te lo digo claro,",
            "CON FLOR QUIERO"
        ],
        [
            "Si pensás que podés,",
            "o que sos el primero,",
            "vamos mano a mano,",
            "y te digo de frente",
            "CON FLOR QUIERO"
        ],
        [
            "Mirá bien mis cartas,",
            "que no es un juego ligero,",
            "te la juego a todo,",
            "y te desafío:",
            "CON FLOR QUIERO"
        ],
        [
            "Si creías que",
            "esto era un paseo,",
            "te aviso ahora,",
            "me la juego entera,",
            "CON FLOR QUIERO"
        ],
        [
            "Sin miedo,",
            "sin titubeo,",
            "te miro a los ojos",
            "y oloroso te canto",
            "CON FLOR QUIERO"
        ],
        [
            "Si querés competir,",
            "no es un mero juego,",
            "con esta mano segura,",
            "te digo",
            "CON FLOR QUIERO"
        ],
        [
            "No te rindas ahora,",
            "no es un simple duelo,",
            "si te animás, vení,",
            "y aceptá mi",
            "CON FLOR QUIERO"
        ],
        [
            "La jugada está hecha,",
            "no hay más que un sendero,",
            "te juego con olorosa,",
            "CON FLOR QUIERO"
        ]
    ],
    "say_con_flor_me_achico": [
        [
            "No es por miedo,",
            "ni porque me siento flojo,",
            "pero en esta ronda",
            "CON FLOR ME ACHICO"
        ],
        [
            "Aunque este asado",
            "pinte bien rico,",
            "prefiero no arriesgar,",
            "y te digo claro:",
            "CON FLOR ME ACHICO"
        ],
        [
            "La jugada está dura,",
            "con el tanto en veintipico,",
            "así que en esta ocasión",
            "CON FLOR ME ACHICO"
        ],
        [
            "No me siento seguro,",
            "no encuentro un mate rico,",
            "en esta mano complicada,",
            "CON FLOR ME ACHICO"
        ],
        [
            "Con estas cartas",
            "no me ubico,",
            "te digo suave:",
            "CON FLOR ME ACHICO"
        ],
        [
            "No es por falta de ganas,",
            "ni por falta de estilo,",
            "pero en esta mano",
            "CON FLOR ME ACHICO"
        ],
        [
            "Hoy la suerte",
            "no está de mi lado,",
            "mejor no arriesgo,",
            "y te digo sereno:",
            "CON FLOR ME ACHICO"
        ],
        [
            "Aunque el juego",
            "sea tentador,",
            "prefiero no apostar más,",
            "y por eso te canto:",
            "CON FLOR ME ACHICO"
        ],
        [
            "No es que no quiera,",
            "ni que no me animo,",
            "pero en esta vuelta",
            "CON FLOR ME ACHICO"
        ],
    ],
    "say_truco": [
        [
            "No te hagas el vivo,",
            "ni te creas astuto,",
            "que con estas cartas",
            "te canto un buen",
            "TRUCO"
        ],
        [
            "No es juego sencillo,",
            "ni un mero asunto,",
            "preparate bien,",
            "porque te canto",
            "TRUCO"
        ],
        [
            "Con unos buenos mates",
            "y fideos con tuco,",
            "te miro a los ojos",
            "y te grito",
            "TRUCO"
        ],
        [
            "No te confíes,",
            "ni te pongas bruto,",
            "que en esta jugada",
            "te tiro un",
            "TRUCO"
        ],
        [
            "De la mano al vaso,",
            "y sin disimulo,",
            "te desafío ahora,",
            "y te canto",
            "TRUCO"
        ],
        [
            "No hay miedo,",
            "no hay apuro,",
            "pero con esta carta",
            "te lanzo un",
            "TRUCO"
        ],
        [
            "Con esta carta",
            "que traigo seguro,",
            "no me achico nada,",
            "y te canto",
            "TRUCO"
        ],
        [
            "No es casualidad,",
            "ni un simple murmullo,",
            "esta mano es buena,",
            "te juego y te digo",
            "TRUCO"
        ],
        [
            "Si creías que ganabas,",
            "con cara de susto,",
            "te aviso de una,",
            "te canto",
            "TRUCO"
        ],
        [
            "No te agrandes,",
            "ni te hagas el duro,",
            "que en esta ronda",
            "te canto",
            "TRUCO"
        ],
        [
            "El juego es picante,",
            "no es nada seguro,",
            "pero con esta carta,",
            "te grito",
            "TRUCO"
        ]
    ],
    "say_quiero_retruco": [
        [
            "No es por jactarme,",
            "ni por estar caduco,",
            "pero en esta mano,",
            "¡QUIERO RETRUCO!"
        ],
        [
            "Aunque te sorprenda,",
            "o te parezca bonito,",
            "con estas cartas,",
            "QUIERO RETRUCO grito"
        ],
        [
            "No hay vuelta atrás,",
            "no es por agredir,",
            "pero con esta mano,",
            "QUIERO RETRUCO te voy a decir"
        ],
        [
            "En esta ronda,",
            "no te hagas el bruto,",
            "te aviso bien claro,",
            "que te lanzo un",
            "QUIERO RETRUCO"
        ],
        [
            "Si pensabas ganar,",
            "con ese as bailarín,",
            "mirá bien tus cartas,",
            "y QUIERO RETRUCO al fin"
        ],
        [
            "No es un simple juego,",
            "ni un mero apuro,",
            "te canto este",
            "QUIERO RETRUCO"
        ],
        [
            "Con tu mameluco,",
            "hacé lo que quieras,",
            "pero en esta mesa,",
            "QUIERO RETRUCO"
        ],
        [
            "En esta mesa",
            "soy yo quien educo,",
            "no cantes el tanto",
            "sino el QUIERO RETRUCO"
        ],
        [
            "En esta silla tan cómoda,",
            "con gusto me acurruco",
            "y ya bien descansado",
            "te canto QUIERO RETRUCO"
        ]
    ],
    "say_quiero_vale_cuatro": [
        [
            "Soy un mago de la suerte,",
            "mi rival se siente perdido",
            "con esta mano no hay otra:",
            "¡QUIERO VALE CUATRO, digo!"
        ],
        [
            "Te idolatro, mi pasión,",
            "pero en este juego de azar,",
            "no hay compasión",
            "QUIERO VALE CUATRO, sin parar"
        ],
        [
            "En este teatro de la vida,",
            "Soy el actor principal",
            "la suerte me ha sido esquiva,",
            "pero QUIERO VALE CUATRO, al final"
        ],
        [
            "A vos que te gusta la música",
            "te canto esta canción",
            "y ya que vengo cargado,",
            "QUIERO VALE CUATRO, ¡sin ton ni son!"
        ],
        [
            "Este juego es mi obsesión,",
            "y el triunfo mi destino",
            "por querer ganar defino",
            "QUIERO VALE CUATRO, ¡con devoción!"
        ],
        [
            "Usté' necesita ayuda,",
            "pero que el pánico no cunda",
            "con dos anchos asevero",
            "QUIERO VALE CUATRO, ¡sin ninguna duda!"
        ],
        [
            "No me creo este cuento",
            "este vil teleteatro",
            "te contesto con certeza",
            "QUIERO VALE CUATRO"
        ],
        [
            "Con esta mano caliente",
            "retrucar considero",
            "y por eso te digo",
            "VALE CUATRO QUIERO"
        ],
        [
            "No es por ser maleducado",
            "pero ser honesto prefiero",
            "me abalanzo en esta mesa",
            "y VALE CUATRO QUIERO"
        ]
    ],
    "say_contraflor_al_resto": [
        [
            "No me creas un loco,",
            "ni pienses en el gesto,",
            "que te juego con firmeza",
            "y te lanzo de frente:",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "Si pensabas que es broma",
            "o que solo es un cuento,",
            "te aviso con esta mano",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "Aunque digas que es mucho",
            "y que no estoy dispuesto",
            "te lo juego completo",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "Si crees que estoy flojo",
            "o que te va bien el gesto,",
            "preparate porque canto",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "Hoy la jugada es dura,",
            "y no soy ningún modesto",
            "te lo digo sin vueltas:",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "No es que quiera ofender,",
            "ofender detesto,",
            "pero en esta mano",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "Aunque parezca exagerado",
            "y no alcance el presupuesto,",
            "hoy decreto con urgencia",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "No hay más vuelta atrás",
            "al pretérito compuesto,",
            "hoy en modio imperativo:",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "Si pensabas que era en joda",
            "no estabas bien predispuesto,",
            "tengo tres del mismo palo:",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "No me estoy haciendo el loco,",
            "no reculo ni protesto,",
            "solo proclamo vehemente:",
            "CONTRAFLOR AL RESTO"
        ],
        [
            "En esta noche estrellada",
            "de Febrero bisiesto,",
            "no hay nada más que decir",
            "que CONTRAFLOR AL RESTO"
        ]
    ],
    "say_contraflor": [
        [
            "Te crees el más vivo",
            "pero yo soy el mejor,",
            "pero con esta mano,",
            "te canto CONTRAFLOR"
        ],
        [
            "Aunque me digas tonto,",
            "no me causa temor,",
            "me queda solo pendiente",
            "cantarte CONTRAFLOR"
        ],
        [
            "No es un simple gesto,",
            "ni es un mero show,",
            "te aumento al doble",
            "con esta CONTRAFLOR"
        ],
        [
            "Si pensabas que esto es fácil,",
            "te lo dedico con amor",
            "prepárate a ganarle",
            "a esta dulce",
            "CONTRAFLOR"
        ],
        [
            "No es en blanco y negro",
            "sino a todo color",
            "te lo digo en serio:",
            "chupate esta CONTRAFLOR"
        ],
        [
            "Si te duele algo",
            "andá al doctor",
            "sino basta de llorar",
            "y contestame esta CONTRAFLOR"
        ],
        [
            "Si sos un chico pobre",
            "de allá del interior",
            "juguemos nena",
            "esta rica CONTRAFLOR"
        ],
        [
            "Hoy no tengo cartas",
            "de menor valor",
            "con tres del mismo palo",
            "te canto CONTRAFLOR"
        ],
        [
            "Con estas rimas me siento",
            "un destacado escritor",
            "y si se me acaba el papel",
            "termino con esta CONTRAFLOR"
        ],

    ]

}